// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__1OKK3","active":"downloadDropdown_active__3dGGK"};